export default __webpack_public_path__ + "static/media/gseBackground.b8ecdf9b.jpg";